import styled from '@emotion/styled/macro';

import { StandardText } from '../../../../Typography/Typography';

export const Description = styled(StandardText)`
  margin-bottom: 2rem;
`;
